module.exports = __webpack_public_path__ + "static/logo26-44a6077eb20889f2b0939a21c035fefb.png";